export class FormatNumber {
  static format(value: any, n: number = 2, x: number = 3, s: string = ' ', c: string = '.'): string {
    // tslint:disable-next-line: triple-equals
    if (value == undefined) {
      return '-';
    }
    const intVal = parseFloat(value);
    if (isNaN(intVal)) {
      return value.toString()
    }
    const re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\D' : '$') + ')'
// tslint:disable-next-line: no-bitwise
    const num = intVal.toFixed(Math.max(0, ~~n));

    const result = (c ? num.replace('.', c) : num).replace(new RegExp(re, 'g'), '$&' + (s || ','));
    if (result.includes(c)) {
      return result;
    } else {
      return result + c + '0'.repeat(n);
    }
  };
}
